import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { addEmailCampaign } from '../../utils/api';
import './HomepageHub.css';
import medialogos from '../../assets/design/logos/medialogos.png';
import bg from '../../assets/design/homepage/background1.png';
import badge1 from '../../assets/design/homepagehub/sxsw.png';
import badge2 from '../../assets/design/homepagehub/ph1.png';
import vector from '../../assets/design/homepagehub/bg_vector.png';
import herologos from '../../assets/design/homepagehub/hp_hero_logos.png';
import softwarehub from '../../assets/design/homepagehub/softwarehub.png';
import communityhub from '../../assets/design/homepagehub/communityhub.png';
import commhub from '../../assets/design/homepagehub/commhub.png';
import eventhub from '../../assets/design/homepagehub/eventhub.png';
import hub1 from '../../assets/design/homepagehub/hub1b.png';
import hub2 from '../../assets/design/homepagehub/softwarehub2.png';
import hub3 from '../../assets/design/homepagehub/hub3b.png';
import pattern1 from '../../assets/design/homepagehub/pattern_1.png';
import pattern2 from '../../assets/design/homepagehub/pattern_2.png';
import vendor1 from '../../assets/design/homepagehub/vendor1.png';
import vendor2 from '../../assets/design/homepagehub/vendor2.png';
import blog1 from '../../assets/design/homepagehub/blog1.png';
import blog2 from '../../assets/design/homepagehub/blog2.png';
import blog3 from '../../assets/design/homepagehub/blog3.png';
import footer from '../../assets/design/homepagehub/footer.png';
import hpiconsoftware from '../../assets/design/homepagehub/hp_icon_software.png';
import hpiconevents from '../../assets/design/homepagehub/hp_icon_events.png';
import hpiconvendor from '../../assets/design/homepagehub/hp_icon_vendor.png';
import hpiconcontent from '../../assets/design/homepagehub/hp_icon_content.png';
import hpiconcommunity from '../../assets/design/homepagehub/hp_icon_community.png';
import booking from '../../assets/design/homepagehub/software/booking.png';
import relevant from '../../assets/design/homepagehub/software/rel.png';
import StartDiscovering from './StartDiscovering';

function HomepageHub() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [pageBreakdown, setPageBreakdown] = useState([]);
  const [data, setData] = useState([]);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newsletterLoading, setNewsletterLoading] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterDone, setNewsletterDone] = useState(false);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';
  const navigate = useNavigate();

  useEffect(() => {
    async function loadData(){
      
    }

    loadData();
  }, []);

  async function handleNewsletterSubmit(){
    setNewsletterLoading(true);

    if (newsletterEmail.length === 0){
      alert('Must enter a valid email');
      setNewsletterLoading(false);
      return;
    }

    let res = await addEmailCampaign(newsletterEmail, 'Discover');

    if (res.success){
      setNewsletterDone(true);
      setNewsletterLoading(false);
      setNewsletterEmail('');
    }
  }

  return (
    <div className='homepagehub'>
      <Helmet>
        <title>LeadrPro - Discover new software</title>
        <link rel="canonical" href={`https://www.leadrpro.com`} />
      </Helmet>

      <div className='homepagehub__hero'>
        <div className='homepagehub__hero-h1'>
          A software community<br/>
          full of software solutions.
        </div>

        <div className='homepagehub__hero-subheader'>
          Browse our community of software solutions and discover new and innovative ways to push the boundaries of your business. Also gain unlimited exclusive access to our library of educational segments from top industry leaders and experts.
        </div>

        <div className='homepagehub__hero-btns'>
          <button onClick={() => navigate('/join-now')} className='homepagehub__hero-btn homepagehub__hero-btn--primary'>
            Become a member, it's free
          </button>

          <div className='homepagehub__hero-btn' onClick={() => navigate('/software-hub')}>
            Learn more
          </div>
        </div>

        <div className='homepagehub__hero-badges'>
          <div className='homepagehub__hero-badge'>
            <a href='https://www.producthunt.com/posts/leadrpro-for-events?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-leadrpro&#0045;for&#0045;events' target='_blank'>
              <img src={badge2} alt='' className='homepagehub__hero-badge--ph' />
            </a>
          </div>

          <div className='homepagehub__hero-badge'>
            <img src={badge1} alt='' className='homepagehub__hero-badge--sxsw' />
          </div>
        </div>
      </div>

      <div className='homepagehub__hero-vector'>
        <img src={herologos} alt='' />
      </div>

      <div className='homepagehub__section homepagehub__section-info'>
        <div className='homepagehub__section-info-top'>
          <div className='homepagehub__section-info-top-header'>
            {/* <div className='homepagehub__section-info-top-label'>
              Built for growth
            </div> */}

            Become a member and take advantage of our <span className='homepagehub__section-info-top-highlight'>LeadrPro Platform</span>
          </div>

          {/* <div className='homepagehub__section-info-top-copy'>
            LeadrPro is a connected platform that easily enables the growth of your business by providing software solutions, networking events, marketing opportunities and a library of educational segments with Thought Leadrs who share their knowledge and experience with you.
            <br/><br/>

            Growing your business has never been this easy thanks to LeadrPro.
          </div> */}
        </div>

        {/* <h2 className='homepagehub__section-info-h2'>A community that takes your company farther, faster</h2> */}

        <div className='homepagehub__section-info-cards'>
          <div className='homepagehub__section-info-card'>
            <div className='homepagehub__section-info-card-icon'>
              <img src={hpiconsoftware} alt='' />
            </div>

            <div className='homepagehub__section-info-card-name'>
              Software Hub
            </div>

            <div className='homepagehub__section-info-card-description'>
              Discover new and innovative software solutions while getting paid for your time.
            </div>

            <div className='homepagehub__section-info-card-btn'>
              <Link to={'/software-hub'} className='btn'>Learn more</Link>
            </div>
          </div>

          <div className='homepagehub__section-info-card'>
            <div className='homepagehub__section-info-card-icon'>
              <img src={hpiconevents} alt='' />
            </div>

            <div className='homepagehub__section-info-card-name'>
              Events Hub
            </div>

            <div className='homepagehub__section-info-card-description'>
            Gain access to events and webinars and build personal connections with Industry Leaders.
            </div>

            <div className='homepagehub__section-info-card-btn'>
              <Link to={'/events-hub'} className='btn'>Learn more</Link>
            </div>
          </div>

          <div className='homepagehub__section-info-card'>
            <div className='homepagehub__section-info-card-icon'>
              <img src={hpiconcontent} alt='' />
            </div>

            <div className='homepagehub__section-info-card-name'>
              Content Hub
            </div>

            <div className='homepagehub__section-info-card-description'>
            Educational segments that focus on addressing hot button issues by bringing you a panel of curated experts and Thought Leadrs.
            </div>

            <div className='homepagehub__section-info-card-btn'>
              <Link className='btn' to={'/blog'}>Learn more</Link>
            </div>
          </div>

          <div className='homepagehub__section-info-card'>
            <div className='homepagehub__section-info-card-icon'>
              <img src={hpiconvendor} alt='' />
            </div>

            <div className='homepagehub__section-info-card-name'>
              Vendor Hub
            </div>

            <div className='homepagehub__section-info-card-description'>
            As a vendor you have free access to thousands of buyer leads where you can get in contact and demo your product through our video calling feature.
            </div>

            <div className='homepagehub__section-info-card-btn'>
              <Link className='btn' to={'/vendor-hub'}>Learn more</Link>
            </div>
          </div>

          <div className='homepagehub__section-info-card'>
            <div className='homepagehub__section-info-card-icon'>
              <img src={hpiconcommunity} alt='' />
            </div>

            <div className='homepagehub__section-info-card-name'>
              Communities Hub
            </div>

            <div className='homepagehub__section-info-card-description'>
            Building a startup alone is a thing of the past. Meet and network with industry leaders and learn the inside outs of building a successful business.
            </div>

            <div className='homepagehub__section-info-card-btn'>
              <button className='btn btn--coming-soon'>Coming soon</button>
            </div>
          </div>
        </div>
      </div>

      <StartDiscovering />

      <div className='homepagehub__section homepagehub__hub-descriptions'>
        <div className='homepagehub__hub-descriptions-pattern1'>
          <img src={pattern1} alt='' />
        </div>

        <div className='homepagehub__hub-descriptions-pattern2'>
          <img src={pattern2} alt='' />
        </div>

        <div className='homepagehub__hub-description-item'>
          <div className='homepagehub__hub-description-info'>
            <div className='homepagehub__hub-description-info-label'>
              Software Hub
            </div>

            <div className='homepagehub__hub-description-info-header'>
              Get paid while you search for ways to upgrade your business
            </div>

            <div className='homepagehub__hub-description-info-copy'>
              LeadrPro is a connected platform that easily enables the growth of your business by providing software solutions, networking events, marketing opportunities and a library of educational segments with experts.
            </div>

            <div className='homepagehub__hub-description-info-btn'>
              <button className='btn' onClick={() => navigate('/software')}>Start today</button>
            </div>
          </div>

          <div className='homepagehub__hub-description-vector'>
            <div className='homepagehub__hub-description-vector-image'>
              <img src={booking} alt='' style={{maxHeight: '380px'}} />
            </div>
          </div>
        </div>

        <div className='homepagehub__hub-description-item' style={{flexDirection: 'row-reverse'}}>
          <div className='homepagehub__hub-description-info'>
            <div className='homepagehub__hub-description-info-label'>
              Software Hub
            </div>

            <div className='homepagehub__hub-description-info-header'>
              Avoid the cold calls and emails by being in control of what your business needs.
            </div>

            <div className='homepagehub__hub-description-info-copy'>
            Research from hundreds of reviews and discussions for what your business truly needs. Then, book a demo and get in contact with a representative of that company through our video meeting feature.
            </div>

            <div className='homepagehub__hub-description-info-btn'>
              <button className='btn' onClick={() => navigate('/software')}>Book a demo</button>
            </div>
          </div>

          <div className='homepagehub__hub-description-vector'>
            <div>
              <img src={relevant} alt='' style={{maxHeight: '480px'}} />
            </div>
          </div>
        </div>

        <div className='homepagehub__hub-description-item'>
          <div className='homepagehub__hub-description-info'>
            <div className='homepagehub__hub-description-info-label'>
              Events Hub
            </div>

            <div className='homepagehub__hub-description-info-header'>
              Keep up with the latest industry insights with real-life professionals and industry experts.
            </div>

            <div className='homepagehub__hub-description-info-copy'>
              Discover in-person events or online webinars where you can meet and network with industry experts who also share their stories and experiences building successful businesses.
            </div>

            <div className='homepagehub__hub-description-info-btn'>
              <button className='btn' onClick={() => navigate('/events')}>Explore events</button>
            </div>
          </div>

          <div className='homepagehub__hub-description-vector'>
            <div>
              <img src={hub3} alt='' style={{maxHeight: '320px'}} />
            </div>
          </div>
        </div>
      </div>

      <div className='homepagehub__vendor-hub'>
        <div className='homepagehub__hub-description-item'>
          <div className='homepagehub__hub-description-info'>
            <div className='homepagehub__vendor-hub-description-info-label'>
              Become a vendor on LeadrPro
            </div>

            <div className='homepagehub__hub-description-info-header'>
              Get interested buyer leads and boost your sales 
            </div>

            <div className='homepagehub__hub-description-info-copy'>
              We do the hard work for you by matching you with ideal customers who require a solution like yours for their business.
            </div>

            <div className='homepagehub__hub-description-list'>
              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6297 0.137767C9.40019 1.63135 3.09508 7.25644 0.640686 15.2946C0.0611068 17.1924 0 17.7392 0 21.03C0 24.307 0.0627523 24.8724 0.630345 26.7302C2.85113 33.9965 8.00576 39.1525 15.2564 41.3602C17.1568 41.939 17.7044 42 21 42C24.2956 42 24.8432 41.939 26.7436 41.3602C33.9949 39.1525 39.1484 34.0052 41.3605 26.7615C41.9387 24.8682 42 24.3192 42 21.03C42 17.7481 41.938 17.1893 41.3659 15.3174C39.1411 8.03538 33.9226 2.83531 26.707 0.710414C25.0982 0.236571 23.995 0.0837861 21.7051 0.0168989C20.0893 -0.0300394 18.2553 0.024176 17.6297 0.137767ZM16.4891 2.49783C10.5631 3.95315 5.55771 8.28627 3.24903 13.9599C0.971841 19.5559 1.67692 26.3442 5.07755 31.563C5.8844 32.8012 6.08206 32.9841 6.21955 32.6191C6.31097 32.3765 6.61463 31.5313 6.89432 30.7414C8.06546 27.4338 11.0064 24.2118 14.2907 22.6381L16.1944 21.7259L17.1806 22.2019C18.4854 22.8313 20.6665 23.1101 22.4165 22.8712C23.1956 22.7646 24.277 22.4635 24.8194 22.2019L25.8056 21.7259L27.7093 22.6381C30.9936 24.2118 33.9345 27.4338 35.1057 30.7414C35.3854 31.5313 35.689 32.3765 35.7804 32.6191C35.9179 32.9841 36.1156 32.8012 36.9224 31.563C39.0553 28.2895 40.034 24.9769 40.034 21.03C40.034 12.112 34.0774 4.56312 25.4011 2.48609C22.8539 1.87636 18.9999 1.88129 16.4891 2.49783ZM18.8847 6.21558C17.5829 6.64249 16.3467 7.43176 15.4392 8.41465C12.0847 12.0489 13.221 18.0776 17.6718 20.2603C18.8098 20.8183 19.2911 20.9127 21 20.9127C22.7089 20.9127 23.1902 20.8183 24.3282 20.2603C29.8349 17.5599 29.8878 9.56769 24.4173 6.77016C23.4951 6.29843 22.8163 6.1487 21.3525 6.09354C20.3184 6.05482 19.2079 6.10974 18.8847 6.21558Z" fill="#13062C"/>
</svg>

                </div>

                <div className='homepagehub__hub-description-list-item-description'>Free public company profile</div>
              </div>

              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="44" height="39" viewBox="0 0 44 39" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9872 0.221266C10.2492 0.836849 10.1551 1.13951 10.1551 6.11189C10.1551 9.33964 10.2063 10.2156 10.3902 10.1392C12.4506 9.28392 14.0697 9.30311 15.9179 10.2048C18.6208 11.5233 19.9153 14.8139 18.8371 17.6257L18.4916 18.5266L19.6887 19.1416C20.9518 19.7906 21.7118 20.5517 23.0026 22.4594C24.109 24.095 24.4428 24.1412 25.6538 22.8258C26.9231 21.4472 27.5776 21.1419 29.0632 21.2357C31.0105 21.3585 32.138 22.501 32.3407 24.5563L32.4417 25.5813H36.8614C41.7829 25.5813 42.156 25.5028 42.8872 24.3142C43.2404 23.7405 43.2545 23.3003 43.2545 12.8149C43.2545 2.32949 43.2404 1.88929 42.8872 1.31564C42.6854 0.987437 42.2414 0.568103 41.9006 0.383782C41.3215 0.0703063 40.3492 0.0458911 26.9876 0.00954884C15.4184 -0.0219478 12.5593 0.0184949 11.9872 0.221266ZM11.4878 11.0735C10.4173 11.4628 9.17341 12.7014 8.75044 13.7989C8.25148 15.0935 8.40909 16.8004 9.13523 17.9669C10.1559 19.607 12.4701 20.5698 14.2497 20.0949C18.5955 18.9353 19.1843 13.2555 15.172 11.1994C14.3351 10.7706 12.4936 10.7076 11.4878 11.0735ZM7.52214 20.0945C6.15993 20.8369 4.66645 22.3166 3.97604 23.6086C3.67004 24.1811 2.65013 26.5832 1.70958 28.9466C0.45965 32.0871 -0.000563699 33.4667 5.18082e-07 34.0718C0.00131702 35.7622 1.3812 36.9333 2.85569 36.4956C3.92676 36.1776 4.44509 35.6103 5.16559 33.968L5.81971 32.477L5.8246 34.5342C5.83043 36.951 6.20996 37.9791 7.33407 38.623C7.95132 38.9765 8.31505 39 13.1782 39H18.3643L19.0376 38.5426C20.2853 37.6952 20.4011 37.3115 20.4032 34.0153C20.4041 32.4014 20.451 31.0804 20.507 31.08C20.5631 31.0796 20.9228 31.611 21.3065 32.2608C21.6964 32.9211 22.2153 33.5378 22.4829 33.6586C23.1344 33.9527 24.1705 33.9305 24.7983 33.6088C25.0836 33.4626 26.508 31.7986 27.9633 29.9113C30.8591 26.1561 30.9744 25.9829 31.0329 25.3017C31.1314 24.152 31.0142 23.7567 30.3917 23.1398C29.8343 22.5874 29.6312 22.5062 28.8076 22.5062C27.6293 22.5062 27.2325 22.8152 25.4701 25.1053L24.1729 26.7908L23.6055 25.8381C21.3611 22.0688 20.0404 20.5539 18.4862 19.9658C17.6786 19.6601 17.6459 19.6625 17.1509 20.0604C15.9995 20.9867 14.6555 21.4567 13.1658 21.4543C11.5602 21.4517 10.4645 21.0639 9.36844 20.1102C8.99813 19.788 8.66374 19.5257 8.62575 19.5276C8.58776 19.5295 8.09106 19.7846 7.52214 20.0945Z" fill="#13062C"/>
<path d="M17.7275 5.67236L36.873 5.67236" stroke="#F9E5FF" stroke-width="3" stroke-linecap="round"/>
<path d="M23.3994 9.92725L36.8721 9.92725" stroke="#F9E5FF" stroke-width="3" stroke-linecap="round"/>
</svg>

                </div>

                <div className='homepagehub__hub-description-list-item-description'>Demo your product with our video meeting feature</div>
              </div>

              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.4642 0.0985418C9.88556 1.19969 2.78541 7.45053 0.627519 15.8017C0.00366421 18.2159 -0.167323 21.1828 0.169904 23.7378C1.32803 32.5095 7.85664 39.6287 16.5003 41.545C18.292 41.9422 19.5308 42.0459 21.7342 41.9829C23.4016 41.9353 23.9367 41.8785 25.1986 41.6157C31.2502 40.3548 36.2576 36.6947 39.3679 31.2589C40.4627 29.3454 41.3101 27.0007 41.7603 24.6386C42.0616 23.0582 42.083 19.4089 41.8009 17.7269C40.8629 12.1344 37.9579 7.38839 33.4216 4.03727C30.4814 1.86539 27.0227 0.502265 23.4032 0.0889436C22.3274 -0.0339111 19.4525 -0.0283542 18.4642 0.0985418ZM29.463 13.6671C29.4075 13.6885 29.2257 13.7359 29.059 13.7723C28.8336 13.8215 27.4083 15.1843 23.4914 19.096L18.2266 24.3535L16.1691 22.3363C15.0375 21.2267 13.9661 20.2445 13.7884 20.1534C13.3967 19.9527 12.5576 19.938 12.1136 20.1239C11.4594 20.3979 10.8303 21.3463 10.8303 22.0589C10.8303 22.8135 10.9717 22.9911 13.9943 26.0354C15.9124 27.9673 17.0803 29.0675 17.3434 29.1905C17.8692 29.4362 18.5432 29.4302 19.1109 29.1748C19.7459 28.8891 31.444 17.2017 31.6941 16.6032C32.105 15.6197 31.7588 14.488 30.8913 13.9795C30.4922 13.7455 29.7057 13.5735 29.463 13.6671Z" fill="#13062C"/>
</svg>

                </div>

                <div className='homepagehub__hub-description-list-item-description'>Only pay for demos you complete</div>
              </div>
            </div>

            <div className='homepagehub__hub-description-info-btn' onClick={() => navigate('/signup/seller')}>
              <button>Start selling today for free</button>
            </div>
          </div>

          <div className='homepagehub__hub-description-vector' style={{paddingLeft: '80px'}}>
            <div>
              <img src={vendor1} alt='' />
            </div>
          </div>
        </div>

        <div className='homepagehub__hub-description-item' style={{flexDirection: 'row-reverse'}}>
          <div className='homepagehub__hub-description-info'>
            <div className='homepagehub__hub-description-info-header'>
              Manage your sales team and assign demos 
            </div>

            <div className='homepagehub__hub-description-info-copy'>
              Our easy to use dashboard allows you to manage your sales/marketing team and easily assign demos.
            </div>

            <div className='homepagehub__hub-description-list'>
              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0442 0.138662C6.89481 1.19876 4.02976 5.48533 4.70755 9.61996C5.48384 14.3574 9.57684 17.4178 14.2684 16.7691C18.7589 16.1483 22.1393 11.4483 21.2725 7.03114C20.4808 2.99609 17.3763 0.202341 13.4754 0.0147237C12.5746 -0.0286547 11.4807 0.0271176 11.0442 0.138662ZM6.94871 18.4974C4.17115 19.903 1.97121 22.4168 0.825481 25.4944C0.337474 26.8053 -0.093045 29.6871 0.0174909 30.9049C0.044121 31.1987 0.0751893 31.5594 0.0868135 31.7062C0.117459 32.0979 25.8827 32.0979 25.9133 31.7062C25.925 31.5594 25.956 31.1987 25.9827 30.9049C26.0924 29.6959 25.6644 26.8096 25.1844 25.5202C24.0486 22.4696 21.7914 19.884 19.0552 18.4993C17.9856 17.958 17.296 17.7221 17.1455 17.8461C16.6197 18.2792 14.518 18.7247 13.0001 18.7247C11.4822 18.7247 9.3805 18.2792 8.85466 17.8461C8.70418 17.7221 8.01581 17.9574 6.94871 18.4974Z" fill="#13062C"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.0442 0.138662C18.8948 1.19876 16.0298 5.48533 16.7076 9.61996C17.4838 14.3574 21.5768 17.4178 26.2684 16.7691C30.7589 16.1483 34.1393 11.4483 33.2725 7.03114C32.4808 2.99609 29.3763 0.202341 25.4754 0.0147237C24.5746 -0.0286547 23.4807 0.0271176 23.0442 0.138662ZM18.9487 18.4974C16.1711 19.903 13.9712 22.4168 12.8255 25.4944C12.3375 26.8053 11.907 29.6871 12.0175 30.9049C12.0441 31.1987 12.0752 31.5594 12.0868 31.7062C12.1175 32.0979 37.8827 32.0979 37.9133 31.7062C37.925 31.5594 37.956 31.1987 37.9827 30.9049C38.0924 29.6959 37.6644 26.8096 37.1844 25.5202C36.0486 22.4696 33.7914 19.884 31.0552 18.4993C29.9856 17.958 29.296 17.7221 29.1455 17.8461C28.6197 18.2792 26.518 18.7247 25.0001 18.7247C23.4822 18.7247 21.3805 18.2792 20.8547 17.8461C20.7042 17.7221 20.0158 17.9574 18.9487 18.4974Z" fill="#13062C" fill-opacity="0.69"/>
</svg>

                </div>

                <div className='homepagehub__hub-description-list-item-description'>Flexible team size</div>
              </div>

              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.20948 0.431932C7.83229 0.807929 7.77617 1.15175 7.77617 3.09026C7.77617 4.61844 7.86782 5.4417 8.06866 5.71533C8.48788 6.28699 10.6063 6.44529 11.3484 5.96067C11.8766 5.61555 11.8926 5.53305 11.8926 3.16002C11.8926 0.20344 11.7624 0 9.87144 0C8.93159 0 8.54097 0.101504 8.20948 0.431932ZM23.3753 0.431932C22.997 0.809009 22.942 1.15175 22.942 3.13151C22.942 5.11127 22.997 5.45401 23.3753 5.83109C23.9213 6.37532 25.8519 6.43298 26.5768 5.92676C27.0262 5.61318 27.0585 5.42723 27.0585 3.15267C27.0585 0.204304 26.9274 0 25.0373 0C24.0974 0 23.7068 0.101504 23.3753 0.431932ZM3.11333 3.85953C2.11412 4.31198 0.999644 5.35294 0.457791 6.3399C0.120893 6.95346 0.0790782 8.10974 0.0233979 18.3331C-0.046365 31.1488 -0.0641306 30.9829 1.55103 32.5593C3.17573 34.1449 3.01648 34.1227 12.7776 34.1227H21.4759L21.3453 33.6367C21.2736 33.3696 21.2133 32.6893 21.2118 32.125L21.2088 31.0991H12.9861C7.53525 31.0991 4.5894 31.0201 4.2473 30.8648C3.02428 30.3093 3.00977 30.1888 3.00977 20.6455V11.8781H17.4173H31.8249V16.0895V20.3008H32.9987C33.6443 20.3008 34.3307 20.3613 34.5242 20.4351C34.8446 20.5578 34.8699 19.9594 34.8125 13.6506L34.7497 6.73123L34.0937 5.80128C33.0115 4.26706 31.8461 3.59087 30.1155 3.49347L28.6416 3.41054L28.5035 4.72599C28.4277 5.44947 28.2431 6.2371 28.0932 6.47618C27.6653 7.15906 26.5686 7.55881 25.1231 7.55881C22.6445 7.55881 21.6421 6.69106 21.6421 4.54609V3.45546H17.5564H13.4709L13.3353 4.74845C13.2608 5.45962 13.0773 6.2371 12.9274 6.47618C12.4995 7.15906 11.4028 7.55881 9.95724 7.55881C7.47871 7.55881 6.47624 6.69106 6.47624 4.54609V3.45546L5.23048 3.46021C4.49602 3.46302 3.62702 3.62694 3.11333 3.85953ZM8.00908 14.9902C7.85395 15.1764 7.78051 15.8688 7.81994 16.7719L7.8845 18.2491H9.61774H11.351L11.4155 16.7719C11.4985 14.8699 11.3397 14.6857 9.61774 14.6857C8.71581 14.6857 8.17763 14.7876 8.00908 14.9902ZM13.0192 14.9449C12.7259 15.2373 12.6682 17.6637 12.944 18.0973C13.0706 18.2958 13.5899 18.3588 14.7282 18.3133L16.334 18.2491L16.3984 16.6484C16.4441 15.5137 16.3808 14.996 16.1817 14.8699C15.7467 14.595 13.3126 14.6524 13.0192 14.9449ZM18.2196 14.8699C18.0205 14.996 17.9572 15.5137 18.0029 16.6484L18.0673 18.2491L19.6731 18.3133C20.8114 18.3588 21.3307 18.2958 21.4573 18.0973C21.7331 17.6637 21.6754 15.2373 21.3821 14.9449C21.0887 14.6524 18.6546 14.595 18.2196 14.8699ZM8.01623 19.9486C7.85309 20.1447 7.77964 20.8146 7.81994 21.7392L7.8845 23.2164H9.61774H11.351V21.4886V19.7609L9.81403 19.6981C8.67551 19.6516 8.20948 19.7166 8.01623 19.9486ZM13.0277 19.9037C12.6453 20.2848 12.6741 22.7691 13.0647 23.0922C13.2515 23.2468 13.9461 23.32 14.8521 23.2807L16.334 23.2164V21.4886V19.7609L14.8151 19.6985C13.8198 19.6577 13.2036 19.7283 13.0277 19.9037ZM18.0497 19.9443C17.9882 20.1045 17.9667 20.9064 18.0025 21.726L18.0673 23.2164L19.5492 23.2807C20.4552 23.32 21.1498 23.2468 21.3366 23.0922C21.7209 22.7743 21.7567 20.2855 21.3821 19.9121C21.0075 19.5387 18.1955 19.5659 18.0497 19.9443ZM23.0365 19.9352C22.9728 20.1004 22.9498 20.9064 22.9856 21.726L23.0503 23.2164L24.5873 23.2792C26.5231 23.3582 26.6674 23.2105 26.5814 21.2381L26.5168 19.7609L24.8345 19.6978C23.553 19.6497 23.1244 19.7063 23.0365 19.9352ZM30.9582 22.9706C29.1578 23.3606 27.7303 24.1431 26.394 25.4721C21.1306 30.7076 23.9614 39.4914 31.3539 40.8619C36.0154 41.726 40.7892 38.4411 41.8174 33.6616C42.8613 28.8099 39.3055 23.7042 34.3164 22.8909C32.745 22.6348 32.4809 22.641 30.9582 22.9706ZM12.894 24.9532C12.6591 25.5633 12.7486 27.7627 13.0192 28.0324C13.3126 28.3248 15.7467 28.3823 16.1817 28.1073C16.3808 27.9812 16.4441 27.4636 16.3984 26.3289L16.334 24.7281L14.6814 24.6655C13.3191 24.6139 13.0051 24.6644 12.894 24.9532ZM18.1035 24.7642C18.0239 24.8432 17.959 25.6103 17.959 26.4688C17.959 27.6927 18.0328 28.0577 18.3017 28.1605C18.907 28.392 21.1134 28.3002 21.3821 28.0324C21.6507 27.7646 21.7428 25.5652 21.5106 24.9618C21.4074 24.6938 21.0413 24.6201 19.8135 24.6201C18.9523 24.6201 18.1828 24.6849 18.1035 24.7642ZM31.2932 25.9317C26.7714 27.0495 25.1679 32.8716 28.4739 36.1672C29.7224 37.4118 30.9756 37.8975 32.9081 37.8861C35.3524 37.8716 37.1745 36.7864 38.2768 34.6885C38.766 33.7575 38.8579 33.3098 38.8581 31.855C38.8588 29.8793 38.4439 28.8567 37.0967 27.5139C35.6848 26.1064 33.2602 25.4456 31.2932 25.9317ZM32.3106 27.6888C32.1826 27.8426 32.009 28.9922 31.9247 30.2432L31.772 32.518L33.1516 33.6443C34.5924 34.8204 35.1516 35.0133 35.3823 34.4136C35.4727 34.1792 35.183 33.6292 34.5389 32.812C33.6617 31.6989 33.5568 31.446 33.5455 30.4154C33.5193 27.9795 33.008 26.8511 32.3106 27.6888Z" fill="#13062C"/>
</svg>
                </div>

                <div className='homepagehub__hub-description-list-item-description'>
                  Flexible scheduling tools for booking demos
                </div>
              </div>

              <div className='homepagehub__hub-description-list-item'>
                <div className='homepagehub__hub-description-list-item-icon'>
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.1818 0.0144502C17.4796 0.114062 14.7937 0.747806 12.3219 1.86902C8.72815 3.49914 5.65029 6.12687 3.46311 9.4322C2.16473 11.3944 1.15895 13.6776 0.611551 15.9055C0.320498 17.0901 0.160245 18.0875 0.0427992 19.4457C-0.0186912 20.1571 -0.0128559 21.947 0.053432 22.6977C0.18753 24.2167 0.420806 25.4903 0.816919 26.8663C1.41356 28.9387 2.39413 31.0251 3.60198 32.7919C3.72049 32.9653 3.81745 33.1217 3.81745 33.1396C3.81745 33.1574 2.96154 35.1531 1.91542 37.5744C0.869299 39.9957 0.0169668 41.9803 0.0213491 41.9847C0.0257083 41.989 1.66785 41.2852 3.67053 40.4206C5.67319 39.556 7.65781 38.6993 8.0808 38.5168C8.50376 38.3343 8.85782 38.185 8.8676 38.185C8.87738 38.185 9.09281 38.3234 9.34633 38.4925C12.1375 40.3545 15.2991 41.5104 18.625 41.885C19.5405 41.9881 19.787 42 21.0006 42C22.2141 42 22.4587 41.9882 23.3763 41.885C26.3279 41.5533 29.1739 40.5964 31.7257 39.0775C33.241 38.1757 34.5496 37.1586 35.8109 35.9024C36.9094 34.8084 37.7275 33.8079 38.5747 32.5228C40.0822 30.2359 41.1529 27.5854 41.6445 24.9234C41.6691 24.7902 41.6994 24.6293 41.7119 24.5659C41.7847 24.1942 41.903 23.2202 41.9585 22.5363C42.0139 21.8525 42.0138 20.1685 41.9584 19.4919C41.847 18.1318 41.6739 17.0532 41.3792 15.8824C39.7728 9.50176 35.2854 4.25994 29.2044 1.66067C26.4184 0.469865 23.2937 -0.100268 20.1818 0.0144502ZM12.2937 18.1653C11.0754 18.4106 10.1346 19.3995 9.97365 20.604C9.93656 20.8815 9.95969 21.4212 10.0189 21.6599C10.2998 22.7924 11.1464 23.6126 12.2822 23.8523C12.5552 23.9099 13.1203 23.9103 13.3884 23.853C14.2587 23.667 14.9862 23.1294 15.387 22.3761C16.1547 20.933 15.5961 19.1613 14.1421 18.4273C13.8923 18.3012 13.5957 18.2022 13.3265 18.1551C13.0498 18.1067 12.5606 18.1115 12.2937 18.1653ZM20.5739 18.1653C19.593 18.3628 18.7819 19.0389 18.4182 19.9625C18.3912 20.031 18.3427 20.1867 18.3105 20.3084C18.2306 20.6097 18.2088 21.1889 18.2658 21.4984C18.4854 22.6917 19.3727 23.6012 20.5624 23.8523C20.8354 23.9099 21.4005 23.9103 21.6686 23.853C22.5764 23.659 23.3104 23.0963 23.7169 22.2826C23.8222 22.0718 23.9161 21.7895 23.97 21.5215C24.0263 21.242 24.0193 20.7318 23.955 20.4275C23.7076 19.2559 22.7826 18.3608 21.6067 18.1551C21.3301 18.1067 20.8408 18.1115 20.5739 18.1653ZM28.6649 18.155C27.639 18.3426 26.7833 19.0631 26.4335 20.0339C26.196 20.6929 26.2142 21.4605 26.4827 22.1096C26.8538 23.0068 27.6327 23.6442 28.6132 23.8529C28.8779 23.9093 29.421 23.9091 29.7063 23.8527C30.2785 23.7394 30.7781 23.4723 31.197 23.0558C31.7534 22.5026 32.048 21.7947 32.0485 21.01C32.0493 19.5941 31.0341 18.3915 29.6384 18.1549C29.3878 18.1125 28.8973 18.1125 28.6649 18.155Z" fill="#13062C"/>
</svg>

                </div>

                <div className='homepagehub__hub-description-list-item-description'>
                  Directly chat with interested leads
                </div>
              </div>
            </div>

            <div className='homepagehub__hub-description-info-btn' onClick={() => navigate('/vendor-hub')}>
              <button>Learn other vendor benefits</button>
            </div>
          </div>

          <div className='homepagehub__hub-description-vector' style={{paddingRight: '80px'}}>
            <div>
              <img src={vendor2} alt='' />
            </div>
          </div>
        </div>
      </div>

      <div className='homepagehub__blog'>
        <h2>Stay on top of the latest trends and solutions</h2>

        <div className='homepagehub__blog-subheader'>Explore our LeadrPro blog</div>

        <div className='homepagehub__blog-articles'>
          <div className='homepagehub__blog-article'>
            <div className='homepagehub__blog-article-thumbnail'>
              <img src={blog1} alt='' />
            </div>

            <div className='homepagehub__blog-article-title'>
              The Future of Energy: How AI is Transforming New Energy Solutions in B2B Markets
            </div>

            <div className='homepagehub__blog-article-link'>
              <a href='https://www.leadrpro.com/blog/the-future-of-energy-how-ai-is-transforming-new-energy-solutions-in-b2b-markets'>
              Read more <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.292893 9.29289C-0.0976311 9.68342 -0.0976311 10.3166 0.292893 10.7071C0.683418 11.0976 1.31658 11.0976 1.70711 10.7071L0.292893 9.29289ZM11 1C11 0.447715 10.5523 -3.74211e-07 10 4.72575e-08L1 -1.63477e-07C0.447715 -1.63477e-07 2.8711e-07 0.447715 2.8711e-07 1C2.8711e-07 1.55228 0.447715 2 1 2L9 2L9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10L11 1ZM1.70711 10.7071L10.7071 1.70711L9.29289 0.292893L0.292893 9.29289L1.70711 10.7071Z" fill="#19202C" fill-opacity="0.5"/>
</svg>
        </a>
            </div>
          </div>

          <div className='homepagehub__blog-article'>
            <div className='homepagehub__blog-article-thumbnail'>
              <img src={blog2} alt='' />
            </div>

            <div className='homepagehub__blog-article-title'>
            Navigating the Future: How AI is Transforming B2B Startups in the Climate Tech Industry
            </div>

            <div className='homepagehub__blog-article-link'>
              <a href='https://www.leadrpro.com/blog/navigating-the-future-how-ai-is-transforming-b2b-startups-in-the-climate-tech-industry'>
              Read more <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.292893 9.29289C-0.0976311 9.68342 -0.0976311 10.3166 0.292893 10.7071C0.683418 11.0976 1.31658 11.0976 1.70711 10.7071L0.292893 9.29289ZM11 1C11 0.447715 10.5523 -3.74211e-07 10 4.72575e-08L1 -1.63477e-07C0.447715 -1.63477e-07 2.8711e-07 0.447715 2.8711e-07 1C2.8711e-07 1.55228 0.447715 2 1 2L9 2L9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10L11 1ZM1.70711 10.7071L10.7071 1.70711L9.29289 0.292893L0.292893 9.29289L1.70711 10.7071Z" fill="#19202C" fill-opacity="0.5"/>
</svg>
              </a>
            </div>
          </div>

          <div className='homepagehub__blog-article'>
            <div className='homepagehub__blog-article-thumbnail'>
              <img src={blog3} alt='' />
            </div>

            <div className='homepagehub__blog-article-title'>
              The Role of AI in Streamlining Supply Chains for Climate Tech Startups
            </div>

            <div className='homepagehub__blog-article-link'>
              <a href='https://www.leadrpro.com/blog/the-role-of-ai-in-streamlining-supply-chains-for-climate-tech-startups'>
              Read more <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.292893 9.29289C-0.0976311 9.68342 -0.0976311 10.3166 0.292893 10.7071C0.683418 11.0976 1.31658 11.0976 1.70711 10.7071L0.292893 9.29289ZM11 1C11 0.447715 10.5523 -3.74211e-07 10 4.72575e-08L1 -1.63477e-07C0.447715 -1.63477e-07 2.8711e-07 0.447715 2.8711e-07 1C2.8711e-07 1.55228 0.447715 2 1 2L9 2L9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10L11 1ZM1.70711 10.7071L10.7071 1.70711L9.29289 0.292893L0.292893 9.29289L1.70711 10.7071Z" fill="#19202C" fill-opacity="0.5"/>
</svg>
</a>
            </div>
          </div>
        </div>

        <div className='homepagehub__blog-newsletter'>
          <div className='homepagehub__blog-newsletter-copy'>
            Subscribe and stay up to date with the latest tips and news.
          </div>

          <div className='homepagehub__blog-newsletter-input-wrapper'>
            <div className='homepagehub__blog-newsletter-input'>
              <input type='text' placeholder='Your email address' onChange={(e) => setNewsletterEmail(e.target.value)} />

              {newsletterLoading && (
                <Spinner />
              )}

              {newsletterDone && !newsletterLoading && (
                <button>Success!</button>
              )}

              {newsletterLoading === false && newsletterDone === false && (
              <button className='homepagehub__blog-newsletter-btn' onClick={() => handleNewsletterSubmit()}>
                Subscribe
              </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='homepagehub__become-a-member'>
          <img onClick={() => navigate('/join-now')} src={footer} alt=''/>
        </div>
    </div>
  );
}

export default HomepageHub;